import { create } from 'zustand'
import fetcher from "../fetcher";

export const useLeadsStore = create((set, get) => ({
    leads: [],
    has_more: true,
    loading: false,
    current_page: 0,
    count: 0,

    search: "",
    setSearch: (value) => set(() => ({search: value})),

    fetchListLeads: async (params) => {
        set({loading: true})
        const response = await fetcher.getLeads(params)
        if (response?.data) {
            const { results, has_more, current_page, count } = response?.data

            if (current_page === 1) {
                set({
                    leads: results,
                    loading: false,
                    has_more: has_more,
                    current_page: current_page,
                    count: count
                })
            } else {
                const currentPage = get().current_page
                if (current_page !== currentPage) {
                    const currentList = get().leads

                    const newList = currentList.concat(results)
                    set({
                        leads: newList,
                        loading: false,
                        has_more: has_more,
                        current_page: current_page,
                        count: count
                    })
                }
            }
        }
    },
    shouldFetchNextLeads: () => {
        return !Boolean(get().loading) && Boolean(get().has_more)
    },

    removeDeletedLeadFromList: (leadId) =>
        set((state) => ({
            leads: state.leads.filter((lead) => lead.id !== leadId),
        })),

    addCreatedLeadToList: (newLead) =>
        set((state) => ({
            leads: [newLead, ...state.leads],
        })),
}))